import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 删除Api
import { deleteItemImport } from 'api/payroll/wage/step2';
import { itemlist, createitem, updateitem } from 'api/payroll';
export default {
  data: function data() {
    return {
      visible: false,
      rules: {
        name: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('1399'),
          trigger: 'blur'
        }]
      },
      isAdd: false,
      // 添加
      load: false,
      form: {
        name: '',
        cate_id: '4',
        // 默认
        settlement_type: 1
      },
      tableData: []
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
      this.getList();
    },
    handlerName: function handlerName(e) {
      this.form.name = String(e.target.value).trim();
    },
    // 获取列表
    getList: function getList() {
      var _this = this;
      itemlist(this.form).then(function (res) {
        var data = res.data;
        data.forEach(function (item) {
          return item.isEdit = false;
        });
        _this.$nextTick(function () {
          return _this.tableData = data;
        });
      }).finally(function () {
        _this.isAdd = false;
        _this.form.name = '';
      });
    },
    // 添加
    handlerAdd: function handlerAdd() {
      var _this2 = this;
      this.tableData.forEach(function (item, i) {
        item.isEdit = false;
      });
      this.$nextTick(function () {
        return _this2.isAdd = true;
      });
      this.form.name = '';
      this.form.id = '';
    },
    // 添加保存
    handlerAddSave: function handlerAddSave() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this3.load = true;
          createitem(_this3.form).then(function (res) {
            _this3.getList();
            _this3.isAdd = false;
            _this3.form.name = '';
          }).finally(function () {
            return _this3.load = false;
          });
        }
      });
    },
    // 保存
    handlerSave: function handlerSave() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.load = true;
          updateitem(_this4.form).then(function () {
            _this4.getList();
            _this4.form.name = '';
            _this4.form.id = '';
          }).finally(function () {
            return _this4.load = false;
          });
        }
      });
    },
    // 编辑
    handlerEdit: function handlerEdit(row, index) {
      this.isAdd = false;
      this.tableData.forEach(function (item, i) {
        item.isEdit = i === index;
      });
      this.form.name = row.name;
      this.form.id = row.id;
    },
    handlerCancel: function handlerCancel(row) {
      row.isEdit = false;
      this.form.name = '';
      this.form.id = '';
    },
    // 删除
    handlerDel: function handlerDel(row) {
      var _this5 = this;
      deleteItemImport(row).then(function (res) {
        _this5.$message({
          type: 'success',
          message: res.message
        });
        _this5.getList();
      });
      // this.$confirm(this.$t('1640', { x: row.name }), this.$t('229'), {
      //   confirmButtonText: this.$t('131'),
      //   cancelButtonText: this.$t('66'),
      //   type: 'warning'
      // }).then(() => {
      //   this.load = true
      //   deleteItemImport(row)
      //     .then(() => {
      //       this.getList()
      //     })
      //     .finally(() => (this.load = false))
      // })
    }
  }
};